import {persianCopy} from './persianTranslations.js';
const localizedCopy = {
  "tr": [
    "Mahmut Efendim’in sohbet kayıtlarına dayalı kaynaklı araştırma asistanı.",
    "Mahmut Efendim AI’ı aç",
    "Sorunuzu yazın; cevap ve dayandığı kaynaklar bu konuşmada gösterilecek.",
    "Yeni soru",
    "Mahmut Efendim AI’a sorun",
    "Kaynaklı cevap hizmeti henüz hazır değil. Sorunuz hesabınıza kaydedilir; doğrulanmış cevap varmış gibi gösterilmez."
  ],
  "en": [
    "A source-based research assistant for Mahmut Efendim’s recorded talks.",
    "Open Mahmut Efendim AI",
    "Write your question; the answer and its sources will appear in this conversation.",
    "New question",
    "Ask Mahmut Efendim AI",
    "The source-based answer service is not ready yet. Your question is saved to your account; no verified answer is claimed."
  ],
  "de": [
    "Ein quellenbasierter Rechercheassistent für Mahmut Efendims aufgezeichnete Gespräche.",
    "Mahmut Efendim AI öffnen",
    "Stellen Sie Ihre Frage; Antwort und Quellen erscheinen in diesem Gespräch.",
    "Neue Frage",
    "Mahmut Efendim AI fragen",
    "Der quellenbasierte Antwortdienst ist noch nicht bereit. Ihre Frage wird im Konto gespeichert; eine geprüfte Antwort wird nicht behauptet."
  ],
  "fr": [
    "Un assistant de recherche fondé sur les sources des entretiens de Mahmut Efendim.",
    "Ouvrir Mahmut Efendim AI",
    "Écrivez votre question; la réponse et ses sources apparaîtront dans cette conversation.",
    "Nouvelle question",
    "Interroger Mahmut Efendim AI",
    "Le service de réponses sourcées n’est pas encore prêt. Votre question est enregistrée dans votre compte; aucune réponse vérifiée n’est annoncée."
  ],
  "es": [
    "Un asistente de investigación basado en las conversaciones grabadas de Mahmut Efendim.",
    "Abrir Mahmut Efendim AI",
    "Escriba su pregunta; la respuesta y sus fuentes aparecerán en esta conversación.",
    "Nueva pregunta",
    "Preguntar a Mahmut Efendim AI",
    "El servicio de respuestas con fuentes aún no está listo. La pregunta se guarda en su cuenta; no se presenta como una respuesta verificada."
  ],
  "ru": [
    "Исследовательский помощник на основе записанных бесед Mahmut Efendim.",
    "Открыть Mahmut Efendim AI",
    "Напишите вопрос; ответ и источники появятся в этом разговоре.",
    "Новый вопрос",
    "Спросить Mahmut Efendim AI",
    "Сервис ответов с источниками ещё не готов. Вопрос сохраняется в вашем аккаунте; проверенный ответ не заявляется."
  ],
  "ar": [
    "مساعد بحث يستند إلى تسجيلات أحاديث Mahmut Efendim.",
    "افتح Mahmut Efendim AI",
    "اكتب سؤالك؛ ستظهر الإجابة ومصادرها في هذه المحادثة.",
    "سؤال جديد",
    "اسأل Mahmut Efendim AI",
    "خدمة الإجابات الموثقة غير جاهزة بعد. يُحفظ سؤالك في حسابك ولا يُعرض كإجابة موثقة."
  ],
  "zh": [
    "基于 Mahmut Efendim 讲座录音的来源研究助手。",
    "打开 Mahmut Efendim AI",
    "输入问题；回答及其来源将在此对话中显示。",
    "新问题",
    "向 Mahmut Efendim AI 提问",
    "来源回答服务尚未准备就绪。问题将保存到您的账户，不会声称已有核实的回答。"
  ]
};

localizedCopy.fa=persianCopy(localizedCopy.tr);
export default localizedCopy;
